"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyStatusLikelihoodToJSON = exports.SurveyStatusLikelihoodFromJSONTyped = exports.SurveyStatusLikelihoodFromJSON = exports.SurveyStatusLikelihood = void 0;
/**
 *
 * @export
 */
exports.SurveyStatusLikelihood = {
    LikelihoodUnspecified: 'LIKELIHOOD_UNSPECIFIED',
    ResultsUnlikely: 'RESULTS_UNLIKELY',
    ResultsLikely: 'RESULTS_LIKELY'
};
function SurveyStatusLikelihoodFromJSON(json) {
    return SurveyStatusLikelihoodFromJSONTyped(json, false);
}
exports.SurveyStatusLikelihoodFromJSON = SurveyStatusLikelihoodFromJSON;
function SurveyStatusLikelihoodFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.SurveyStatusLikelihoodFromJSONTyped = SurveyStatusLikelihoodFromJSONTyped;
function SurveyStatusLikelihoodToJSON(value) {
    return value;
}
exports.SurveyStatusLikelihoodToJSON = SurveyStatusLikelihoodToJSON;
